import styled from 'styled-components';
import { spacing } from '@naf/theme';

export const Icons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  flex: 1;
`;

export const IconWrapper = styled.a`
  border-radius: 50%;
  border: 1px solid #fff;
  display: bl;
  width: 44px;
  height: 44px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  &:not(:first-child) {
    margin-left: ${spacing.space12};
  }

  &:hover {
    border-color: #d3eac2;
    svg path {
      fill: #d3eac2 !important;
    }
  }
`;

export const SizedIcon = styled.span`
  padding: 0;
  margin: 0;
  height: ${spacing.space20};

  svg {
    width: 25px;
  }
`;
